import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-aktivieren-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerAktivierenAdminEffects {

    BenutzerAktivierenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_AKTIVIEREN_ADMIN),
        mergeMap((x: ac.PostBenutzerAktivierenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerAktivierenAdmin(x.benutzerAktivierenRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerAktivierenAdminErfolgreichAction(result, x.benutzerAktivierenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerAktivierenAdminFehlerAction(error, x.benutzerAktivierenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminCommandService);
        }
        return this.service;
    }
}
